import { TServerDeTectFaceData, TSign, TSwap, TTemplate, TVideoTemplate } from "@/types";
import { getExtension } from "./index";
import { faceDetect, getSignUrl, putFileTo } from "@/api";
import { APICode, VIDEO_TYPE_LIMIT } from "@/constants";
import { uploadVideo } from "./video";

export const submitFile = (file: File, url: string) => {
  return new Promise<void>((resolve, reject) => {
    putFileTo(file, url)
      .then(() => {
        resolve();
      })
      .catch(reject);
  });
};

export const fetchSign = (extension: string) => {
  return new Promise<TSign>((resolve, reject) => {
    getSignUrl(extension)
      .then((res) => {
        const { code, data, msg } = res;
        if (code === APICode.Success) {
          resolve(data);
        } else {
          reject(new Error(msg));
        }
      })
      .catch(reject);
  });
};

export const signTemp = (value: TTemplate) => {
  if (value.resource.url) {
    // 上传过
    return Promise.resolve(value);
  } else {
    return new Promise<TTemplate>((resolve, reject) => {
      fetchSign(getExtension(value.resource.file!))
        .then((sign) =>
          resolve({
            ...value,
            resource: {
              ...value.resource,
              sign: sign as TSign,
            },
          })
        )
        .catch(reject);
    });
  }
};

export const uploadTemp = (value: TTemplate) => {
  if (value.resource.url) {
    return Promise.resolve(value);
  } else {
    return new Promise<TTemplate>((resolve, reject) => {
      submitFile(value.resource.file!, value.resource.sign?.uploadUrl!)
        .then(() =>
          resolve({
            ...value,
            resource: {
              ...value.resource,
              url: value.resource.sign?.downloadUrl,
            },
          })
        )
        .catch(reject);
    });
  }
};

export const signSwap = (value: TSwap, prop: "source" | "target") => {
  const swapObj = value[prop];

  if (value.source && value.target) {
    if (swapObj?.resource.url) {
      // 上传过了，不签名
      return Promise.resolve(value);
    } else {
      return new Promise<TSwap>((resolve, reject) => {
        fetchSign(getExtension(swapObj?.resource.file!))
          .then((sign) =>
            resolve({
              ...value,
              [prop]: {
                ...swapObj,
                resource: {
                  ...swapObj?.resource,
                  sign,
                },
              },
            })
          )
          .catch(reject);
      });
    }
  } else {
    // 没有选择目标图，不签名
    return Promise.resolve(value);
  }
};

export const uploadSwap = (value: TSwap, prop: "source" | "target") => {
  const swapObj = value[prop];

  if (value.source && value.target) {
    if (swapObj?.resource.url) {
      // 上传过了，不再上传
      return Promise.resolve(value);
    } else {
      return new Promise<TSwap>((resolve, reject) => {
        submitFile(
          swapObj?.resource.file!,
          swapObj?.resource.sign?.uploadUrl!
        )
          .then(() =>
            resolve({
              ...value,
              [prop]: {
                ...swapObj,
                resource: {
                  ...swapObj?.resource,
                  url: swapObj?.resource.sign?.downloadUrl,
                },
              },
            })
          )
          .catch(reject);
      });
    }
  } else {
    // 没有选择目标图，不上传
    return Promise.resolve(value);
  }
};

export const checkTempFace = (value: TTemplate) => {
  return new Promise<TServerDeTectFaceData[]>((resolve, reject) => {
    if (value.resource.url) {
      faceDetect(value.resource.url).then((res) => {
        const { faces } = res;
        if (faces) {
          resolve(faces as TServerDeTectFaceData[]);
        } else {
          reject(new Error("face not found"));
        }
        // resolve(faces as TServerDeTectFaceData[]);
        // 判断显示人脸的信息在业务中处理的，这里就不判断了

        // if (faces?.length > 0) {
        //   resolve(faces as TServerDeTectFaceData[]);
        // } else {
        //   reject(new Error("face not found"));
        // }
      });
    }
  });
};

/**
 * 校验上传选择的视频，如果上传了就跳过
 * @param value 
 * @returns 
 */
export const checkUploadVideo = (value: TVideoTemplate) => {
  return new Promise<TVideoTemplate>(async (resolve, reject) => {
    if (value.resource.url) {
      // 上传过了，不再上传
      resolve(value);
    } else {
      const videoUrl = await uploadVideo(value.resource.file!)
      resolve({
        ...value,
        resource: {
          ...value?.resource,
          url: videoUrl,
        },
      })
    }
  });
}